const bootstrapSelect = require('bootstrap-select');

if ($('.selectpicker').length) {
    $('.selectpicker').selectpicker();
    $('.bootstrap-select .dropdown-toggle').append('<div class="select-arrow"></div>');

    $('.selectpicker').on('show.bs.select', function() {
        $(this).parents('.form-group').find('.input-underline').addClass('active');
        $(this).parents('.form-group').find('label').addClass('label-select');
        $(this).parents('.bootstrap-select').find('.select-arrow').addClass('active');
    });
    $('.selectpicker').on('hide.bs.select', function() {
        $(this).parents('.form-group').find('.input-underline').removeClass('active');
        $(this).parents('.form-group').find('label').removeClass('label-select');
        $(this).parents('.bootstrap-select').find('.select-arrow').removeClass('active');
    });

    select_country();

function select_country() {

    $('.emname_country').selectpicker('val', '20');
    $('.emname_code').val('+' + '20');

    $('#emname_country.selectpicker').on('hide.bs.select', function(e) {
        //    console.log($('#emname_country').val());
        var countryCode = $(this).val();
        var countryCodeNumber = $(this).parent().next().val('+' + countryCode);
        $('.emnamenumber').focus();
    });

    function ipLookUp() {
        $.ajax('http://ip-api.com/json')
            .then(
                function success(response) {
                    console.log('User\'s Location Data is ', response);
                    console.log('User\'s Country', response.country);
                    console.log('User\'s Country', response.countryCode);
                    var countryVal = $('#emname_country option[data-countryCode="' + response.countryCode + '"]').val();
                    $('#emname_country').selectpicker('val', countryVal);
                    var countryCode = $('#emname_country').val();
                    var countryCodeNumber = $('.emname_code').val('+' + countryCode);
                    console.log('country selected');
                },
                function fail(data, status) {
                    console.log('Request failed.  Returned status of',
                        status);
                }
            );
    }
    // ipLookUp();


}

}
